import PropTypes from 'prop-types';

const allowedUnorderedListProps = {
  title: PropTypes.string.isRequired,
  ariaLive: PropTypes.string,
  ariaAtomic: PropTypes.bool,
  htmlAttributes: PropTypes.object,
  ariaRelevant: PropTypes.arrayOf(
    PropTypes.oneOf([
      'additions',
      'removals',
      'text',
      'all'
    ])
  )
};

export { allowedUnorderedListProps };